const MAX_TRY = 30;
let timer;
const handlers = [];
let tryCount = 0;
function handleConsentChange() {
    for(let i = 0; i < handlers.length; i++){
        try {
            var ref;
            (ref = handlers[i]) === null || ref === void 0 ? void 0 : ref.call(handlers);
        } catch (e) {}
    }
}
function onConsentChange(handler) {
    clearInterval(timer);
    if (!handlers.includes(handler)) {
        handlers.push(handler);
    }
    if (window.Optanon) {
        window.Optanon.OnConsentChanged(handleConsentChange);
        return;
    }
    timer = setInterval(()=>{
        if (window.Optanon) {
            clearInterval(timer);
            window.Optanon.OnConsentChanged(handleConsentChange);
        } else {
            ++tryCount;
            if (tryCount > MAX_TRY) {
                clearInterval(timer);
            }
        }
    }, 1000);
}

export { MAX_TRY, onConsentChange };
//# sourceMappingURL=event.js.map
